import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { formatDate, formatIDR, clientName } from "../lib/format";
import { Button } from "../components/ui/button";
import { Printer } from "lucide-react";

export default function PrintClientStatement() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/clients/${id}/statement`).then(({ data }) => setS(data)); }, [id]);
  if (!s) return <div className="p-10">Memuat...</div>;
  return (
    <div className="min-h-screen bg-white p-6 print:p-10 max-w-3xl mx-auto text-sm">
      <div className="print:hidden mb-4 flex justify-end">
        <Button onClick={() => window.print()} className="bg-brand text-white" data-testid="btn-do-print"><Printer className="w-4 h-4 mr-1.5" /> Cetak</Button>
      </div>
      <div className="border-b-2 border-[#C87D55] pb-4 mb-6 flex justify-between items-start">
        <div>
          <div className="font-display text-2xl font-bold">DESSY WEDDING GROUP</div>
          <div className="text-xs text-[#5C6066]">Wedding & Event Services • Garut, Jawa Barat</div>
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-wider text-[#8C9096] font-semibold">Rekap Pembayaran Klien</div>
          <div className="text-xs mt-1">Dibuat: {formatDate(s.generated_at)}</div>
        </div>
      </div>
      <div className="mb-6">
        <div className="text-[10px] uppercase text-[#8C9096]">Klien</div>
        <div className="font-medium">{clientName(s.client)}</div>
        <div className="text-xs">{s.client?.address}</div>
        <div className="text-xs">{s.client?.whatsapp}</div>
      </div>
      <div className="mb-6">
        <div className="text-[10px] uppercase text-[#8C9096] mb-2">Pemesanan</div>
        <table className="w-full border-t border-b border-[#E5E0D8] text-xs">
          <thead><tr className="bg-[#FAF6EE]"><th className="text-left p-2">Kode</th><th className="text-left p-2">Acara</th><th className="text-left p-2">Tanggal</th><th className="text-right p-2">Nilai</th><th className="text-right p-2">Terbayar</th><th className="text-right p-2">Sisa</th></tr></thead>
          <tbody>{s.bookings.map((b) => (
            <tr key={b.booking_code} className="border-t border-[#F0EBE0]">
              <td className="p-2 font-mono">{b.booking_code}</td>
              <td className="p-2">{b.event_name}</td>
              <td className="p-2">{formatDate(b.event_date)}</td>
              <td className="p-2 text-right font-mono">{formatIDR(b.final_value)}</td>
              <td className="p-2 text-right font-mono">{formatIDR(b.paid)}</td>
              <td className="p-2 text-right font-mono">{formatIDR(b.remaining)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="mb-6">
        <div className="text-[10px] uppercase text-[#8C9096] mb-2">Riwayat Pembayaran</div>
        <table className="w-full border-t border-b border-[#E5E0D8] text-xs">
          <thead><tr className="bg-[#FAF6EE]"><th className="text-left p-2">Tanggal</th><th className="text-left p-2">Booking</th><th className="text-left p-2">Jenis</th><th className="text-left p-2">Metode</th><th className="text-right p-2">Nominal</th></tr></thead>
          <tbody>{s.payments.length === 0 && <tr><td colSpan={5} className="p-4 text-center text-[#8C9096]">Belum ada pembayaran.</td></tr>}
          {s.payments.map((p) => (
            <tr key={p.id} className="border-t border-[#F0EBE0]">
              <td className="p-2">{formatDate(p.payment_date)}</td>
              <td className="p-2 font-mono">{p.booking_code}</td>
              <td className="p-2">{p.payment_type}</td>
              <td className="p-2">{p.method}</td>
              <td className="p-2 text-right font-mono">{formatIDR(p.amount)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="grid grid-cols-3 gap-4 p-4 bg-[#FAF6EE] rounded border border-[#E5E0D8]">
        <div><div className="text-[10px] uppercase text-[#8C9096]">Total Kontrak</div><div className="font-mono font-bold">{formatIDR(s.total_contract)}</div></div>
        <div><div className="text-[10px] uppercase text-[#8C9096]">Total Terbayar</div><div className="font-mono font-bold text-emerald-700">{formatIDR(s.total_paid)}</div></div>
        <div><div className="text-[10px] uppercase text-[#8C9096]">Sisa</div><div className="font-mono font-bold text-rose-700">{formatIDR(s.remaining)}</div></div>
      </div>
      <div className="mt-16 grid grid-cols-2 gap-8">
        <div><div className="text-xs text-[#8C9096] mb-16">Dibuat oleh</div><div className="border-t border-[#5C6066] pt-2 text-sm">{s.generated_by}</div></div>
        <div><div className="text-xs text-[#8C9096] mb-16">Klien</div><div className="border-t border-[#5C6066] pt-2 text-sm">Tanda tangan & nama</div></div>
      </div>
    </div>
  );
}
